import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/types/blockDefinition';
import type {
  BlockStateUnionType,
  BlockType,
  ComponentTypeUnionType,
} from '@unifyapps/defs/types/block';
import type { IconButtonComponentType } from '@unifyapps/defs/types/blocks';
import _pick from 'lodash/pick';
import IconButton from './IconButton';

class IconButtonBlockStateDefinition implements BlockStateDefinition {
  getBlockVersion() {
    return 0;
  }

  getComponent() {
    return IconButton;
  }

  get type(): ComponentTypeUnionType {
    return 'IconButton';
  }

  get initialStateGetter() {
    return (block: BlockType) =>
      ({
        id: block.id,
        ..._pick(block.component as IconButtonComponentType, [
          'content',
          'appearance',
          'componentType',
        ]),
      }) as BlockStateUnionType;
  }
}

export default IconButtonBlockStateDefinition;
